<template>
  <div>
    	<!-- Start Banner Area -->
    <section class="home-banner-area relative">
      <div class="container">
        <div class="row fullscreen d-flex align-items-center justify-content-center">
          <div class="banner-content col-lg-8 col-md-12">
            <h1 class="wow fadeIn" data-wow-duration="4s">We Rank the Best Courses <br> on the Web</h1>
            <p class="text-white">
              Education is old. The current public school system in the US dates back to the 19th century and wasn’t designed to scale the way it has. Lots of companies are working to “disrupt” education by changing the way things work in the classroom and by bringing the classroom online
            </p>

            <div class="input-wrap">
                <router-link to="/main" class="btn search-btn">Explore Our Courses</router-link>
            </div>
            <h4 class="text-white">Top courses</h4>

            <div class="courses pt-20">
              <a href="#" data-wow-duration="1s" data-wow-delay=".3s" class="primary-btn transparent mr-10 mb-10 wow fadeInDown">Vue JS Development</a>
              <a href="#" data-wow-duration="1s" data-wow-delay=".6s" class="primary-btn transparent mr-10 mb-10 wow fadeInDown">Python</a>
              <a href="#" data-wow-duration="1s" data-wow-delay=".9s" class="primary-btn transparent mr-10 mb-10 wow fadeInDown">Marketing</a>
              <a href="#" data-wow-duration="1s" data-wow-delay="1.2s" class="primary-btn transparent mr-10 mb-10 wow fadeInDown">UI/UX Design</a>
              <a href="#" data-wow-duration="1s" data-wow-delay="1.5s" class="primary-btn transparent mr-10 mb-10 wow fadeInDown">Android</a>
              <a href="#" data-wow-duration="1s" data-wow-delay="1.8s" class="primary-btn transparent mr-10 mb-10 wow fadeInDown">DataScience</a>
              <a href="#" data-wow-duration="1s" data-wow-delay="2.1s" class="primary-btn transparent mr-10 mb-10 wow fadeInDown">Cryptocurrency</a>
            </div>
          </div>
        </div>
      </div>
      <div class="rocket-img">
        <img src="../assets/img/rocket.png" alt="">
      </div>
    </section>

    <!-- Start About Area -->
    <section class="about-area section-gap">
      <div class="container">
        <div class="row align-items-center justify-content-center">
          <div class="col-lg-5 col-md-6 about-left">
            <img class="img-fluid" src="../assets/img/about.jpg" alt="">
          </div>
          <div class="offset-lg-1 col-lg-6 offset-md-0 col-md-12 about-right">
            <h1>
              Over 2500 Courses <br> from multiple Platform
            </h1>
            <div class="wow fadeIn" data-wow-duration="1s">
              <p>We’re not one of those companies. We are rethinking education from the bottom up. The web has rethought nearly everything - commerce, social networking, healthcare, and more. We are building the education the world needs - the first truly net native education. We take more cues from modern tech innovators in creating an engaging educational experience than we do from the classroom.</p>
            </div>
            <router-link to="/main" class="primary-btn">Learn Now</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- Start Courses Area -->
    <section class="courses-area section-gap">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5 about-right">
            <h1>
              This is Why <br> We have Solid Idea
            </h1>
            <div class="wow fadeIn" data-wow-duration="1s">
              <p>
                Education is old. The current public school system in the US dates back to the 19th century and wasn’t designed to scale the way it has. Lots of companies are working to “disrupt” education by changing the way things work in the classroom and by bringing the classroom online
              </p>
            </div>
            <router-link to="/main" class="primary-btn">Explore Courses</router-link>
          </div>
          <div class="offset-lg-1 col-lg-6">
            <div class="courses-right">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <ul class="courses-list">
                    <li>
                      <a class="wow fadeInLeft" href="courses.html" data-wow-duration="1s" data-wow-delay=".1s">
                        <i class="fa fa-book"></i> Development
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInLeft" href="courses.html" data-wow-duration="1s" data-wow-delay=".3s">
                        <i class="fa fa-book"></i> IT & Software
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInLeft" href="courses.html" data-wow-duration="1s" data-wow-delay=".5s">
                        <i class="fa fa-book"></i> Photography
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInLeft" href="courses.html" data-wow-duration="1s" data-wow-delay=".7s">
                        <i class="fa fa-book"></i> Language
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInLeft" href="courses.html" data-wow-duration="1s" data-wow-delay=".9s">
                        <i class="fa fa-book"></i> Life Science
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInLeft" href="courses.html" data-wow-duration="1s" data-wow-delay="1.1s">
                        <i class="fa fa-book"></i> Business
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInLeft" href="courses.html" data-wow-duration="1s" data-wow-delay="1.3s">
                        <i class="fa fa-book"></i> Socoal Science
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                  <ul class="courses-list">
                    <li>
                      <a class="wow fadeInRight" href="courses.html" data-wow-duration="1s" data-wow-delay="1.3s">
                        <i class="fa fa-book"></i> Data Science
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInRight" href="courses.html" data-wow-duration="1s" data-wow-delay="1.1s">
                        <i class="fa fa-book"></i> Design
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInRight" href="courses.html" data-wow-duration="1s" data-wow-delay=".9s">
                        <i class="fa fa-book"></i> Training
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInRight" href="courses.html" data-wow-duration="1s" data-wow-delay=".7s">
                        <i class="fa fa-book"></i> Humanities
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInRight" href="courses.html" data-wow-duration="1s" data-wow-delay=".5s">
                        <i class="fa fa-book"></i> Marketing
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInRight" href="courses.html" data-wow-duration="1s" data-wow-delay=".3s">
                        <i class="fa fa-book"></i> Economics
                      </a>
                    </li>
                    <li>
                      <a class="wow fadeInRight" href="courses.html" data-wow-duration="1s" data-wow-delay=".1s">
                        <i class="fa fa-book"></i> Personal Dev
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Courses Area -->

    <!--Start Feature Area -->
    <section class="feature-area">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div class="section-title text-center">
              <h1>Courses That Make Us Hero</h1>
              <p>
                Our Courses can help you get throuhg the industrial standars that all the companies are expecting
              </p>
            </div>
          </div>
        </div>
        <div class="feature-inner row">
          <div class="col-lg-4 col-md-6"
            v-for="(post, index) in posts"
            v-bind:item="post"
            v-bind:index="index"
            v-bind:key="post.id"
          >
            <div class="feature-item">
              <i class="ti-crown"></i>
              <h4>{{post.courseName}}</h4>
              <div class="wow fadeIn" data-wow-duration="1s" data-wow-delay=".1s">
                <p>{{post.authorName}}</p>
                <p>{{post.courseDescription}}</p>
                <p>{{post.totalVideos}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Feature Area -->
  </div>
</template>

<script>
import PostService from '../PostService';
export default {
  name: 'Home',
  data(){
    return {
      posts: [],
      error: '',
      courseName: '',
      courseDescription: '',
      courseLink: '',
      totalVideos: '',
      authorName: '',
      uniqueCourseId: {
        'Angular 6':1,
        'HTML':2,
        'CSS':3,
        'Javascript':4,
        'React JS':5,
        'Vue JS':6,
        'Node JS': 7,
      }
    }
  },
  async created(){
    try{
      this.posts = await PostService.getPosts();
    } catch(err){
      this.error=err.message;
    }
  }
}
</script>

<style scoped>
  .banner-content {
    margin-top: 100px;
  }
  .courses {
    margin-bottom: 30px;
  }

</style>

